/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const ALL_ACC_REC_NDC__DETAIL_TABLE = 'ALL_ACC_REC_NDC__DETAIL_TABLE';
export const NDC_DETAIL = 'NDC_DETAIL';
export const ACC_REC_NDC_DETAIL_ALL_FIELD_CLEAR_REDUX =
  'ACC_REC_NDC_DETAIL_ALL_FIELD_CLEAR_REDUX';
